import i18n from 'i18n';
import { CURRENCY_MAP, CurrencyType } from './currency';
import LOCALS from 'commons/locals';

const RAW_STOCK_PLACE_MAP = {
  JAPAN: 'JP', // 东京银座
  HONGKONG: 'HK', // 香港
  SINGAPORE_ASU: 'SG', // 新加坡 ASU
  SINGAPORE_GX: 'SG_GX', // 新加坡 Ginzaxiaoma
  SINGAPORE_ASU_GST: 'SG_ASU_GST', // 新加坡 ASU GST
  SHANG_HAI: 'SHANG_HAI', // 上海
  UMEDA: 'UMEDA', // 大阪梅田
  DUBAI: 'DUBAI', // 阿联酋迪拜
  FRANCE: 'FRANCE', // 法国巴黎
  NEW_YORK: 'NEW_YORK', // 美国纽约
} as const;

export const STOCK_PLACE_MAP = new Proxy(RAW_STOCK_PLACE_MAP, {
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 STOCK_PLACE_MAP！请直接通过属性精准获取值，如 STOCK_PLACE_MAP.JAPAN',
    );
  },
});

export type StockPlace =
  (typeof RAW_STOCK_PLACE_MAP)[keyof typeof RAW_STOCK_PLACE_MAP];

export const isStockPlace = (stockPlace: string): stockPlace is StockPlace => {
  return Object.values(RAW_STOCK_PLACE_MAP).includes(stockPlace as StockPlace);
};

const RAW_STOCK_PLACE_CONFIG_MAP: Record<
  StockPlace,
  { currency: CurrencyType; label: string }
> = {
  [RAW_STOCK_PLACE_MAP.JAPAN]: {
    currency: CURRENCY_MAP.JPY,
    label: i18n.t(LOCALS.ginza),
  },
  [RAW_STOCK_PLACE_MAP.HONGKONG]: {
    currency: CURRENCY_MAP.HKD,
    label: i18n.t(LOCALS.hongkong),
  },
  [RAW_STOCK_PLACE_MAP.SINGAPORE_ASU]: {
    currency: CURRENCY_MAP.SGD,
    label: i18n.t(LOCALS.ojMPRgDisg),
  },
  [RAW_STOCK_PLACE_MAP.SINGAPORE_GX]: {
    currency: CURRENCY_MAP.SGD,
    label: i18n.t(LOCALS.kkIwEnEVml),
  },
  [RAW_STOCK_PLACE_MAP.SINGAPORE_ASU_GST]: {
    currency: CURRENCY_MAP.SGD,
    label: i18n.t(LOCALS.xoYbOlYPVF),
  },
  [RAW_STOCK_PLACE_MAP.SHANG_HAI]: {
    currency: CURRENCY_MAP.CNY,
    label: i18n.t(LOCALS.shanghai),
  },
  [RAW_STOCK_PLACE_MAP.UMEDA]: {
    currency: CURRENCY_MAP.JPY,
    label: i18n.t(LOCALS.umeda),
  },
  [RAW_STOCK_PLACE_MAP.DUBAI]: {
    currency: CURRENCY_MAP.AED,
    label: i18n.t(LOCALS.dubai),
  },
  [RAW_STOCK_PLACE_MAP.FRANCE]: {
    currency: CURRENCY_MAP.EUR,
    label: i18n.t(LOCALS.france),
  },
  [RAW_STOCK_PLACE_MAP.NEW_YORK]: {
    currency: CURRENCY_MAP.USD,
    label: i18n.t(LOCALS.new_york),
  },
};

const STOCK_PLACE_CONFIG_MAP = new Proxy(RAW_STOCK_PLACE_CONFIG_MAP, {
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 STOCK_PLACE_CONFIG_MAP！请直接通过属性精准获取值，如 STOCK_PLACE_CONFIG_MAP.JAPAN',
    );
  },
});

export const getStockPlaceConfig = (stockPlace: string) => {
  if (!isStockPlace(stockPlace)) {
    throw new Error(`Invalid stockPlace: ${stockPlace}`);
  }

  return STOCK_PLACE_CONFIG_MAP[stockPlace];
};

export const getStockPlaceCurrency = (stockPlace: string) => {
  return getStockPlaceConfig(stockPlace).currency;
};

export const STOCK_PLACE_OPTION_LIST = Object.values(RAW_STOCK_PLACE_MAP).map(
  (stockPlace) => {
    return {
      value: stockPlace,
      label: getStockPlaceConfig(stockPlace).label,
    };
  },
);
